import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import SharedTools from '../../lib/SharedTools';
import { hashHistory, Link } from 'react-router';
import { Button } from 'antd';
import PayModal from "../share/PayModal";

export default class ClassAlbumsIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let role = CurrentRoleStore.getCurrentRole();
    let semester = SharedTools.getCurrentSemester();

    let year = Number(String(semester).substring(0, 4));
    let currentTime = (role.associatObj.pay_slice == 'semester' ? semester : (role.associatObj.pay_slice == 'term'?year:null));

    let showCurrentAlbum = true;
    if (role.roleName == 'parent') {
      if (currentTime){
        let item = role.associatObj.paid_semesters.find(semester => {
          return String(currentTime).indexOf(String(semester)) >= 0 ? true : false
        })
        showCurrentAlbum = item ? true : false
      }
    }

    this.state = {
      role: role,
      albums: [],
      classId: props.location.query.classId,
      class: null,
      semesters: [],
      currentSemesters: [],
      semester,
      // currentTime,
      showCurrentAlbum,
      checkStatus: false,
      showPayModal: false
    };
    // bind this
    this.toAlbumDetail = this.toAlbumDetail.bind(this);
  }

  componentDidMount(){
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    let classId = this.state.classId ? this.state.classId : (this.state.role.associatName == 'classRecord' ? this.state.role.associatObj.id : this.state.role.associatObj.classId);
    if(classId){
      DataService.getClassById(classId).then((res)=>{
        this.setState({
          class: res
        })
      })
    }
    DataService.getAlbumList(classId).then((albums) => {
      let currentSemesters = albums.filter((album) => album.semester == this.state.semester);
      let otherSemesters = albums.filter((album) => album.semester != this.state.semester);
      
      let semestersData = otherSemesters.reduce(function (pre, current, index) {
        pre[current.semester] = pre[current.semester] || []
        pre[current.semester].push(current)
        return pre
      }, {})

      let semesters = [];
      for (var key in semestersData) {
        semesters.push({ semester: key, albums: semestersData[key] })
      }

      semesters.sort(function (x, y) {
        return Number(y.semester) - Number(x.semester);
      });

      this.setState({
        albums: albums,
        classId: classId,
        semesters,
        currentSemesters
      });
    }).catch((error) => {
      console.log(error);
    });
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  toAlbumDetail(e){
    let albumId = e.currentTarget.dataset.id;
    if (albumId)
      if (this.state.role && this.state.role.associatName !== 'student')
        hashHistory.push(`albums/${albumId}/posts?classId=${this.state.classId}`);
      else
        hashHistory.push(`albums/${albumId}/posts?studentId=${this.props.location.query.studentId}`);
    else
      hashHistory.push(`albums/create?classId=${this.state.classId}`);
  }

  callbackPayModal() {
    this.setState({
      showPayModal: false
    })
  }

  _renderAlbumBox(album) {
    return (
      <div className="album-box" key={album.id} data-id={album.id} onClick={this.toAlbumDetail}>
        <div className="album-cover" style={{ backgroundImage: `url(${album.cover})` }}></div>
        <div className="album-cover-back"></div>
        <div className="album-new" style={{ display: 'none' }}>
          <div className="album-new-num">更新21</div>
        </div>
        <div className="album-title">{album.title}</div>
        <div className="album-count">共{album.count}张</div>
      </div>
    )
  }

  render() {
    return (
      <div className="albums-index-page">
        {this.state.class && <div className="albums-class">{this.state.class.name}</div>}
        <div className="albums-wrapper">
          {this.state.showCurrentAlbum ? ((this.state.role.roleName == 'parent' && this.state.currentSemesters.length == 0) ? <div className="album-label">当前学期暂无相册</div>: (this.state.currentSemesters.map(album =>
            this._renderAlbumBox(album)
          ))) : <div className="album-label">本学期未解锁－解锁后方可查看 <Button type="primary" onClick={() => this.setState({ showPayModal: true })}>去解锁</Button></div>}
          {this.state.role.roleName != "parent" && this.state.class && !this.state.class.is_graduated &&
            <div className="album-box" onClick={this.toAlbumDetail.bind(this)}>
              <div className="album-cover-create" ></div>
            </div>
          }
        </div>
        <div className="check-history-ablums" onClick={() => this.setState({ checkStatus: !this.state.checkStatus})}>
          {this.state.checkStatus ? '收起' : '查看'}以往学期相册
        </div>
        <div className="albums-wrapper" style={{display: (this.state.checkStatus ? 'block' : 'none')}}>
          {this.state.semesters.map((item, index) => {
            let role = this.state.role;
            let semester = item.semester;
            let year = Number(String(semester).substring(0, 4));
            let number = String(semester).substring(4, 5);
            let yearSub = Number(String(year).substring(2, 4));
            let semesterToString = (number == '1' ? yearSub + '-' + (yearSub + 1) + '学年上学期' : yearSub + '-' + (yearSub + 1) + '学年下学期');

            // 判断该学期是否已解锁
            let showAlbum = true;
            if (role.roleName == 'parent') {
              let paid_semester = role.associatObj.paid_semesters.find(paid_semester => {
                return String(semester).indexOf(String(paid_semester)) >= 0 ? true : false
              })
              showAlbum = paid_semester ? true : false
            }

            return (<div key={index} className="album-semester-box">
                      <div className="album-semester">
                        <div className="album-semester-label">{semesterToString}</div>
                        <div className="album-line"></div>
                      </div>
                      {showAlbum ? (item.albums.length == 0 ? <div className="album-label">当前学期暂无相册</div> : (item.albums.map((album) =>
                        this._renderAlbumBox(album)
                      ))) : <div className="album-label">该学期未解锁－解锁后方可查看 <Button type="primary" onClick={() => this.setState({ showPayModal: true })}>去解锁</Button></div>}
                    </div>)
          })}
        </div>
        <PayModal visible={this.state.showPayModal} studentId={this.state.role.associatObj.id} callbackPayModal={this.callbackPayModal.bind(this)} />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/album/ClassAlbumsIndexPage.jsx